import { Box, Typography, Button, TextField } from "@mui/material";
import { useState } from "react";

export default function AddTagsModal({ onClose }) {
  const [isAddTagOpen, setIsAddTagOpen] = useState(false);
  const [newTagName, setNewTagName] = useState("");
  const handleAddTag = () => {
    setNewTagName("");
    setIsAddTagOpen(false);
  };
  return (
    <>
      <div style={overlayStyle}>
        <Box sx={modalStyle}>
          {/* Header */}
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h6">Assign Tags</Typography>
            <Typography
              onClick={() => setIsAddTagOpen(true)}
              sx={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
            >
              ADD NEW TAG
            </Typography>
          </Box>
          {/* Content */}
          <Box mt={2}>
            <Typography variant="body2">
              Currently, no tags are available! You can add tags under the
              'Add Tags' option in the settings.
            </Typography>
            <Typography mt={2} variant="body2">
              Existing tags of this report :
            </Typography>
          </Box>
          {/* Footer */}
          <Box mt={4} textAlign="right">
            <Button onClick={onClose} color="error">
              CLOSE
            </Button>
          </Box>
        </Box>
      </div>
      {/* Add New Tag Popup */}
      {isAddTagOpen && (
        <div style={overlayStyle}>
          <Box sx={modalStyle}>
            {/* Header */}
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6">Add Tag</Typography>
              <Typography
                onClick={() => setIsAddTagOpen(false)}
                sx={{ color: "gray", cursor: "pointer", fontSize: "20px" }}
              >
                ✕
              </Typography>
            </Box>
            {/* Content */}
            <Box mt={2}>
              <Typography variant="body2" mb={2}>
                Create tags to assign tags corresponding to a particular report.
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Enter tag name"
                value={newTagName}
                onChange={(e) => setNewTagName(e.target.value)}
                size="small"
              />
            </Box>
            {/* Footer */}
            <Box mt={3} display="flex" justifyContent="flex-end" gap={1}>
              <Button 
                onClick={() => setIsAddTagOpen(false)} 
                variant="outlined"
                color="secondary"
              >
                CANCEL
              </Button>
              <Button 
                onClick={handleAddTag} 
                variant="contained"
                disabled={!newTagName.trim()}
              >
                CREATE
              </Button>
            </Box>
          </Box>
        </div>
      )}
    </>
  );
}
// styles
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};
const modalStyle = {
  width: "600px",
  background: "#fff",
  padding: "20px",
  borderRadius: "8px",
};